module.exports = __webpack_public_path__ + "img/blpjs01_center_003.c4a553cd.png";